import { createSlice } from '@reduxjs/toolkit';

const DEFAULT_STATE = {
  zones: [],
  selectedZone: null
};

const zoneSlice = createSlice({
  name: 'zone',
  initialState: DEFAULT_STATE,
  reducers: {
    setZone: (state, action) => {
      state.zones = action.payload.zones;
      state.selectedZone = action.payload.selected;
    },
    setSelectedZone: (state, action) => {
      if (state.selectedZone === action.payload) return;
      state.selectedZone = action.payload;
    }
  }
});

export const { reducer: zoneReducer, actions: zoneActions } = zoneSlice;

export const selectZone = state => state.zone;
